import clsx from "clsx";

export function Button({
	children,
	type = "button",
	variant = "primary",
	size = "default",
	icon,
	className,
	tag: Tag = "button",
	...props
}) {
	return (
		<Tag
			type={type}
			className={clsx(
				"steam-button",
				{
					"steam-button__default": size === "default",
					"steam-button__compact": size === "compact",
				},
				{
					"steam-button__primary": variant === "primary",
					"steam-button__secondary": variant === "secondary",
					"steam-button__outline": variant === "outline",
				},
				className,
			)}
			{...props}
		>
			<span>{children}</span>

			{icon ? (
				<svg width={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
					<path d="M16.175 13H4V11H16.175L10.575 5.4L12 4L20 12L12 20L10.575 18.6L16.175 13Z"></path>
				</svg>
			) : null}
		</Tag>
	);
}
